module.exports = __webpack_public_path__ + "media/images/home/ic_image@2x-21107327dfea3db264b7d9c7212e1b9d.png";